import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { LaboratorioExService } from '../laboratorioEx.service';
import {
    DocumentoMuestraLaboratorioSolicitudExViewModel,
    SolicitudLaboratorioExViewModel,
    TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel,
    TwTcResultadoEnvioMuestraLaboratorioExEnum,
} from '../laboratorioEx.types';
import { DocumentModule, UploadedFileViewModel } from '../../../../core/components/uploader/document_uploader.types';
import { catchError, of, tap } from 'rxjs';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { TcPerfilUsuarioEnum } from '../../../../core/_infrastructure/types/common';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { SolicitudExService } from '../../datosbasicos/datosbasicosEx.service';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../../types/enum';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-laboratorioex-documentos-edit',
    templateUrl: './laboratorioex-documentos-edit.component.html',
})
export class LaboratorioExDocumentosEditComponent extends ComponentBase implements OnInit, OnDestroy {
    @HostListener('window:beforeunload', ['$event'])
    forceCheckUnload(): boolean {
        // Prevenimos la pérdida de datos, si el usuario recarga accidentalmente la página.
        // Lo controlamos y el navegador le requiere confirmación para finalizar la recarga.
        if (this.filePendingToPurge !== '') {
            this.laboratorioExService.deleteFile(this.filePendingToPurge).subscribe();
        }
        return false;
    }

    isCollapsedCabecera = false;
    visibilitySpinner = false;

    esPerfilInspector = false;
    esPerfilConsultasyLaboratorio = false;
    habilitarGuardar = false;

    idSolicitudEx: number;
    solicitudLaboratorioEx: SolicitudLaboratorioExViewModel;
    IdTipoSolicitudEx: number;
    IdEstadoSolicitudEx: number;
    IdEstadoCertificadoFitoEx: number;
    TituloTipoSolicitudEx: string;
    CodigoTipoSolicitud: string;
    TituloEstadoSolicitudEx: string;
    TituloEstadoCertificadoFitoEx: string;
    esClonada = false;

    formGroup: FormGroup;
    uploadedFile: UploadedFileViewModel;
    payload: DocumentoMuestraLaboratorioSolicitudExViewModel;

    resultadoMuestrasLaboratorioEx: TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel;
    documentosLaboratorioEx: DocumentoMuestraLaboratorioSolicitudExViewModel[];

    idDocumento: number;
    editMode = false;
    documentoLaboratorioEx: DocumentoMuestraLaboratorioSolicitudExViewModel;

    documentModuleLaboratorioEx = DocumentModule.Laboratorio;

    envioMuestrasExCerrado = false;

    private successMessage = 'Documentación guardada correctamente';
    private fileSuccessMessage = 'Documentación cargada. Recuerde GUARDAR antes de abandonar la pantalla';

    private filePendingToPurge = '';
    private docLoaded = false;
    megaSizeLimit = 0;

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idSolicitudEx = params.get('id');
        const idDocumento = params.get('idDocumento');

        if (idSolicitudEx) {
            this.idSolicitudEx = parseInt(idSolicitudEx);

            if (this.idSolicitudEx) {
                this.getSolicitudLaboratorioEx();
            }
        }

        if (idDocumento) {
            this.idDocumento = parseInt(idDocumento);
            this.editMode = true;
            this.getDocumentoSolicitudLaboratorioEx();
        }
    });

    constructor(
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private fb: FormBuilder,
        private router: Router,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private laboratorioExService: LaboratorioExService,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudExportacion.Id) || this.navMenuService.currentSolicitudExportacion.Id !== id) {
            this.solicitudExService.getSolicitudEx(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    ngOnInit(): void {
        this.esPerfilInspector = this.isInspector;
        this.esPerfilConsultasyLaboratorio =
            this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);

        this.guardRefreshPage(this.idSolicitudEx);

        this.buildForm();
        this.initComponent();

        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('laboratorioEx-documentos-edit');
        });
    }

    private initComponent(): void {
        this.buildForm();
        this.createPayload();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            Texto: '',
            NombreArchivo: ['', Validators.required],
        });
        this.form = this.formGroup;
    }

    private getSolicitudLaboratorioEx(): void {
        this.laboratorioExService.getSolicitudLaboratorioEx(this.idSolicitudEx).subscribe(res => {
            this.loading = false;
            this.solicitudLaboratorioEx = res;
            this.IdTipoSolicitudEx = this.solicitudLaboratorioEx.IdTipoSolicitudEx;
            this.IdEstadoSolicitudEx = this.solicitudLaboratorioEx.IdEstadoSolicitudEx;
            this.IdEstadoCertificadoFitoEx = this.solicitudLaboratorioEx.IdEstadoCertificadoFitoEx;
            this.TituloTipoSolicitudEx = this.solicitudLaboratorioEx.IdTipoSolicitudExDescripcion;
            this.esClonada =
                this.solicitudLaboratorioEx.TwSolicitudJerarquiaEx != null &&
                this.solicitudLaboratorioEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            //Si es previa
            if (this.solicitudLaboratorioEx.EsPrevia) {
                if (
                    this.solicitudLaboratorioEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                    this.solicitudLaboratorioEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                ) {
                    this.TituloTipoSolicitudEx += '-Previa';
                }
            }
            this.CodigoTipoSolicitud = this.solicitudLaboratorioEx.CodigoTipoSolicitud;
            this.TituloEstadoSolicitudEx = this.solicitudLaboratorioEx.IdEstadoSolicitudExDescripcion;
            this.TituloEstadoCertificadoFitoEx = this.solicitudLaboratorioEx.IdEstadoCertificadoFitoExDescripcion;

            this.documentosLaboratorioEx = res.TwDocumentoMuestraLaboratorioSolicitudExCollection;

            this.resultadoMuestrasLaboratorioEx = res.TwResultadoEnvioMuestraLaboratorioSolicitudEx;

            if (this.resultadoMuestrasLaboratorioEx) {
                if (
                    this.resultadoMuestrasLaboratorioEx.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Aceptada ||
                    this.resultadoMuestrasLaboratorioEx.IdResultadoEx == TwTcResultadoEnvioMuestraLaboratorioExEnum.Rechazada
                ) {
                    this.envioMuestrasExCerrado = true;
                }
            }

            this.habilitarGuardar =
                this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_LABORATORIO_EXPORTACION,
                    this.solicitudLaboratorioEx.IdEstadoSolicitudEx,
                ).Visible && !this.envioMuestrasExCerrado;
        });
    }

    private createPayload(): void {
        this.payload = new DocumentoMuestraLaboratorioSolicitudExViewModel();
        this.uploadedFile = new UploadedFileViewModel();

        this.payload.Id = null;
        this.payload.IdSolicitudEx = this.idSolicitudEx;
        this.payload.IdUsuario = null;
        this.payload.Fecha = null;
        this.payload.MarkToDelete = 0;

        this.updateForm();
    }

    private updatePayload(): void {
        this.payload = new DocumentoMuestraLaboratorioSolicitudExViewModel();
        this.uploadedFile = new UploadedFileViewModel();

        this.payload.Id = this.idDocumento;
        this.payload.IdSolicitudEx = this.documentoLaboratorioEx.IdSolicitudEx;
        this.payload.Fecha = this.documentoLaboratorioEx.Fecha;
        this.payload.IdUsuario = this.documentoLaboratorioEx.IdUsuario;
        this.payload.MarkToDelete = this.documentoLaboratorioEx.MarkToDelete;
        this.payload.CodigoStorage = this.documentoLaboratorioEx.CodigoStorage;
        this.payload.Texto = this.documentoLaboratorioEx.Texto;
        this.payload.Size = this.documentoLaboratorioEx.Size;
        this.payload.NombreArchivo = this.documentoLaboratorioEx.NombreArchivo;
        this.payload.IdDocFileSystem = this.documentoLaboratorioEx.IdDocFileSystem;

        this.uploadedFile.Guid = this.documentoLaboratorioEx.CodigoStorage;
        this.uploadedFile.Name = this.documentoLaboratorioEx.NombreArchivo;
        this.uploadedFile.Size = this.documentoLaboratorioEx.Size;

        this.updateForm();
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            Texto: this.payload.Texto,
            NombreArchivo: this.payload.NombreArchivo,
        });
        this.cdr.detectChanges();
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel): void {
        this.payload.CodigoStorage = uploadedFile.Guid;
        this.payload.NombreArchivo = uploadedFile.Name;
        this.payload.Size = uploadedFile.Size;
        this.payload.IdUsuario = this.loggedInUser!.Id;

        if (this.filePendingToPurge !== '') {
            this.laboratorioExService.deleteFile(this.filePendingToPurge).subscribe();
        }
        this.filePendingToPurge = uploadedFile.Guid;

        this.addSuccessMessage(this.fileSuccessMessage);

        //en Uploader Local obtenemos el valor para este campo obligatorio en subida local
        this.form.controls['NombreArchivo'].setValue(this.uploadedFile!.Name);

        this.formGroup.markAsPristine();
        this.docLoaded = true;
    }

    get ficheroSubido(): boolean {
        return this.uploadedFile.Guid !== undefined && this.uploadedFile.Guid !== null && this.uploadedFile.Guid !== '' && !this.uploadedFile.MarkToDelete;
    }

    onFileDeleted(deletedFile: UploadedFileViewModel) {
        this.uploadedFile = deletedFile;
    }

    onClickSave(): void {
        this.payload.Texto = this.formGroup.value.Texto;

        if (!this.formGroup.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        if (this.uploadedFile.Name == '' || this.uploadedFile.MarkToDelete) {
            this.addErrorMessage('Debe cargar el documento antes de guardar');
            return;
        }

        this.laboratorioExService
            .persist(this.payload)
            .pipe(
                tap(() => {
                    this.visibilitySpinner = false;
                    this.formGroup.markAsPristine();
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack() {
        this.router.navigate([`/exportacion/solicitud/laboratorioEx/${this.idSolicitudEx}`]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || this.formGroup.pristine || !this.docLoaded;
    }

    private getDocumentoSolicitudLaboratorioEx(): void {
        this.laboratorioExService.getDocumentoLaboratorio(this.idDocumento).subscribe(res => {
            this.documentoLaboratorioEx = res;
            this.updatePayload();
        });
    }

    get title(): string {
        if (this.editMode) {
            return 'Editar';
        } else {
            return 'Nuevo';
        }
    }

    get siTieneAtestacion(): boolean {
        return (
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO ||
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO ||
            this.solicitudLaboratorioEx?.IdSubTipoSolicitudEx === EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO
        );
    }

    ngOnDestroy(): void {
        if (this.filePendingToPurge !== '') {
            this.laboratorioExService.deleteFile(this.filePendingToPurge).subscribe();
        }
    }
}
